import * as React from 'react';

import {cs}                             from "@Common/react/chain-services";
import {UseState}                       from "@Common/react/use-state";
import {Tooltip2}                       from "@Common/ui-components/heavy/common/design2/tooltip-2/tooltip-2";
import {SpinnerStroke}                  from '@Xpresso/routes/common/spinner-stroke';
import {SocialDashboardDeleteModal}     from "@Xpresso/routes/account/common/social-panel/social-accounts/social-dashboard/social-dashboard-table/social-dashboard-delete-modal/social-dashboard-delete-modal";
import {SocialDashboardDescheduleModal} from "@Xpresso/routes/account/common/social-panel/social-accounts/social-dashboard/social-dashboard-table/social-dashboard-deschedule-modal/social-dashboard-deschedule-modal";
import {SocialDashboardRescheduleModal} from "@Xpresso/routes/account/common/social-panel/social-accounts/social-dashboard/social-dashboard-table/social-dashboard-reschedule-modal/social-dashboard-reschedule-modal";

export const IMAGE_SOURCE = {
    Facebook: "assets/facebook-icon-dark.png",
    Instagram: "assets/instagram-icon-dark.jpg",
    LinkedIn: "assets/linkedin-icon-dark.png",
    Twitter: "assets/x-icon-white.svg",
}

const TOOLTIP_DELETE_DEFAULT = 'Delete post'
const TOOLTIP_DELETE_INSTAGRAM = 'Please visit Instagram to delete this post'
const TOOLTIP_DELETE_SCHEDULED = 'Delete scheduled post'

export const SocialDashboardCard = ({post, data, index}) => cs(
    ['isUpdating', ({}, next) => UseState({next, initValue: false})],
    ['tooltip', ({}, next) => Tooltip2({
        direction: 'south-west',
        getMessage: () => tooltipMessage(post),
        next,
    })],
    ["socialDashboardDescheduleModal", ({}, next) => SocialDashboardDescheduleModal({post, data, next})],
    ["socialDashboardDeleteModal", ({}, next) => SocialDashboardDeleteModal({post, data, next})],
    ["socialDashboardRescheduleModal", ({}, next) => SocialDashboardRescheduleModal({post, data, next})],
    ({
        isUpdating, 
        tooltip, 
        socialDashboardDescheduleModal, 
        socialDashboardDeleteModal, 
        socialDashboardRescheduleModal
    }) => (
            <SocialDashboardCardExpanded  
                post={post}  
                isUpdating={isUpdating} 
                tooltip={tooltip} 
                socialDashboardRescheduleModal={socialDashboardRescheduleModal}
                socialDashboardDescheduleModal={socialDashboardDescheduleModal}
                socialDashboardDeleteModal={socialDashboardDeleteModal}
                index={index}
            />
    )
);

const SocialDashboardCardExpanded = ({ 
        post, 
        isUpdating, 
        tooltip, 
        socialDashboardRescheduleModal, 
        socialDashboardDescheduleModal,
        socialDashboardDeleteModal,
        index,
}) => {
    return (
        <div className='post-row' xd-qa-type="card" xd-qa-name={post['shareSite'] + " " + extractPageName(post)}>
            <div className='post-row-img' xd-qa-type="image" xd-qa-name="Image">
                <img src={IMAGE_SOURCE[post['shareSite']]} alt={post['shareSite']} />
            </div>
           
            <div className='post-row-name' xd-qa-type="text" xd-qa-name="Name">
                {extractPageName(post)}
                {
                    isValidLink(post)
                    &&
                    <a  href={post['shareLink']} target='blank' xd-qa-type="link" xd-qa-name="Link">
                        <i className={`fa fa-external-link`} ></i>
                    </a>
                }
            </div>

            <div className='post-row-likes'>
                <div className='post-row-likes-label' xd-qa-type="label" xd-qa-name={'Twitter' == post['shareSite'] ? 'Retweets' : 'Likes'}>
                    {'Twitter' == post['shareSite'] ? 'Retweets' : 'Likes'}
                </div>
                <div className='post-row-likes-value' xd-qa-type="text" xd-qa-name="Likes">
                    {post['likes']?? '--'}
                </div>
            </div>

            <div className='post-row-shares'>
                <div className='post-row-shares-label' xd-qa-type="label" xd-qa-name="Shares">
                    {'Instagram' == post['shareSite'] ? '' : 'Shares'}
                </div>
                <div className='post-row-shares-value' xd-qa-type="text" xd-qa-name="Shares">
                    {'Instagram' == post['shareSite'] ? '' : post['shares']?? '--'}
                </div>
            </div>
            {
                isScheduled(post)
                ?
                ScheduledPost({post, socialDashboardRescheduleModal})
                :
                CompletedPost({post})
            }

            <div className={
                    isScheduled(post)
                    ?
                    'post-row-deschedule'
                    :
                    'Instagram' === post['shareSite'] 
                    ? 
                    'post-row-delete not-allowed' 
                    : 
                    'post-row-delete'
                }
                onMouseEnter={tooltip?.onMouseEnter}
                onMouseLeave={tooltip?.onMouseLeave}
                onClick={tooltip?.onClick}
            >   
            {    
                isUpdating.value 
                ?
                <SpinnerStroke />
                :        
                <i className='fa fa-trash'
                    onClick={async (e) => {
                        e.stopPropagation()
                        isUpdating.onChange(true)

                        isScheduled(post)
                        ?
                        await deschedulePost(socialDashboardDescheduleModal, tooltip)
                        :                        
                        await deletePost(post, socialDashboardDeleteModal, tooltip)

                        isUpdating.onChange(false)
                    }}
                    xd-qa-type="icon"
                    xd-qa-name="Delete"
                >
                    {tooltip && (
                    <div
                        className="tooltip"
                        ref={tooltip?.ref}
                        xd-qa-type="text"
                        xd-qa-name="Tooltip"
                    >
                        {tooltip?.render()}
                    </div>
                )}
                </i>
            }
                
            </div>        
        </div> 
    )
}

const ScheduledPost = ({post, socialDashboardRescheduleModal}) => {
    const localDateTime = utcTimeToLocalTime(post['dateScheduled']['date'])

    return (
        <div className='post-row-scheduled' xd-qa-type="badge" xd-qa-name="Scheduled Info">    
            <div className='post-row-scheduled-label' xd-qa-type="label" xd-qa-name="Scheduled">
                Scheduled
            </div>
            <div className='post-row-scheduled-value'
                onClick={(e) => {
                    e.stopPropagation()
                    socialDashboardRescheduleModal.show()
                }}
                xd-qa-type="link"
                xd-qa-name="Date 1"
            >
                {formattedDate(localDateTime)}
            </div>
            <div className='post-row-scheduled-value'
                onClick={(e) => {
                    e.stopPropagation()
                    socialDashboardRescheduleModal.show()
                }}
                xd-qa-type="link"
                xd-qa-name="Date 2"
            >
                {formattedTime(localDateTime)}
            </div>
        </div>
    )
}

const CompletedPost = ({post}) => {
    return (
        <div className='post-row-posted' xd-qa-type="badge" xd-qa-name="Posted Info">
            <div className='posted-text' xd-qa-type="text" xd-qa-name="Posted Date">
                {`Posted ${formattedDate(post['dateShared']['date'])}`}
            </div>
        </div>
    )
}

const extractPageName = (post) => {
    if("LinkedIn" === post["shareSite"]) {
        return post["shareSite"]
    }

    if("Twitter" === post["shareSite"]) {
        return post["shareSite"]
    }

    if(!post['shareSubSite']) {
        if(!post['shareSite']) {
            return ''
        }
        return post['shareSite']
    }

    if(!post['shareSubSite'].includes('-')) {
        return post['shareSubSite']
    }

    const pageNameSansId = post['shareSubSite'].split('-')[1]

    return pageNameSansId
}

const formattedDate = (dateToFormat) => {
    const date = new Date(dateToFormat)    
    const day = date.getDate()
    const month = monthAbbreviations[date.getMonth()]
    const year = date.getFullYear()

    return `${day} ${month}, ${year}`
}

const monthAbbreviations = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
]

const formattedTime = (dateToFormat) => {
    const date = new Date(dateToFormat)
    const hours = date.getHours()
    const hoursStringified = (0 == hours || 12 == hours)
        ? `12`
        : `${hours % 12}`
    const minutes = date.getMinutes()
    const minutesPadded = minutes < 10 ? `0${minutes}` : `${minutes}`

    const meridiem = hours < 12 ? 'am' : 'pm'

    return `${hoursStringified}:${minutesPadded} ${meridiem}`
}

const isValidLink = (data) => {
    if(!data['shareLink']) {
        return false
    }
    if(!data['shareLink'].includes("https://")) {
        return false
    }
    return true
}

const deschedulePost = async (socialDashboardDescheduleModal, tooltip) => {
    tooltip?.onMouseLeave()
    socialDashboardDescheduleModal.show()
}

const deletePost = async (post, socialDashboardDeleteModal, tooltip) => {   
    if(post['shareSite'] === 'Instagram') {
        return
    }
    tooltip?.onMouseLeave()
    socialDashboardDeleteModal.show()
}

const isScheduled = (post) => {
    if(!post?.shareStatus) {
        return false
    }        

    return (post['shareStatus'] === 'Scheduled')
}

export const utcTimeToLocalTime = (utc) => {
    const now = new Date()

    if(!utc) {
        return now
    }

    const utcParts = utc.split(' ')
    if(utcParts.length < 2) {
        return now
    }

    const date = utcParts[0]
    const dateParts = date.split("-")
    if(dateParts.length < 3) {
        return now
    }
    const year = dateParts[0]
    const ostensiveMonth = dateParts[1] - 1
    const month = ostensiveMonth < 0 
        ? 0 
        : ostensiveMonth
    const day = dateParts[2]

    const time = utcParts[1]
    const timeParts = time.split(":")
    if(timeParts.length < 2) {
        return now
    }
    const hour = timeParts[0]
    const minute = timeParts[1]

    const offsetTimezone = new Date().getTimezoneOffset()
    const local = new Date(Date.UTC(year, month, day, hour, minute)).getTime() + offsetTimezone    
   
    return (new Date(local))
}

const tooltipMessage = (post) => {
    if(isScheduled(post)) {
        return TOOLTIP_DELETE_SCHEDULED
    }

    return 'Instagram' === post['shareSite'] ? TOOLTIP_DELETE_INSTAGRAM : TOOLTIP_DELETE_DEFAULT 
}